import {putAll, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {showBeError} from 'utils/show-be-error';

import {adminAction, SearchManagementOtherSubjectsRolesAction} from '../action';

function* execute({payload}: SearchManagementOtherSubjectsRolesAction): SagaIterator {
    yield* put(adminAction.setLoading('getRoles', true));
    const response = yield* call(Api.searchUserRolesForOtherSubject, {text: payload});

    if (response.isSuccess) {
        yield* put(adminAction.setManagementOtherSubjectsRoles(response.data));
    } else {
        yield putAll(showBeError(response, t('admin')('subjectsLoading')));
    }
    yield* put(adminAction.setLoading('getRoles', false));
}

/** Runs the admin saga that searches roles for the other-subject management form. */
export function* searchManagementOtherSubjectsRolesSaga(): SagaIterator {
    yield takeLatestF('admin/SEARCH_MANAGEMENT_OTHER_SUBJECTS_ROLES', execute);
}
